<template>
  <div data-v-600960a6="" data-v-12b14801="" class="mien">
    <ul data-v-600960a6="" class="nav">
      <li data-v-600960a6="" @click="changNav(0)" :class="nav == 0 ? 'tab active' : 'tab'">{{$store.state.appInfo.title}}赞助</li>
      <li data-v-600960a6="" @click="changNav(1)" :class="nav == 1 ? 'tab active' : 'tab'">品牌历程</li>
    </ul>
    <div data-v-600960a6="" class="main" v-if="nav == 0">
      <div data-v-7d1a9adc="" data-v-600960a6="" class="main">
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="/static/image/sport/signed_welsh_video_img1-1c0a.jpg" src="/static/image/sport/signed_welsh_video_img1-1c0a.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">代言人圣诞祝福</span><span data-v-7d1a9adc="" class="date">2021年12月</span></div>
            <p data-v-7d1a9adc="" class="desc">威尔士祝福您圣诞快乐</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="/static/image/sport/sponsor_french_img1-3b78.jpg" src="/static/image/sport/sponsor_french_img1-3b78.jpg" lazy="loaded" /><!----></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">韦斯利・斯内德祝大家中秋快乐</span><span data-v-7d1a9adc="" class="date">2021年9月</span></div>
            <p data-v-7d1a9adc="" class="desc">斯内德向{{$store.state.appInfo.title}}全体会员献上中秋祝福</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="/static/image/sport/Landing-MilanAcademyShenzhen-25-26.png" src="/static/image/sport/Landing-MilanAcademyShenzhen-25-26.png" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}正式签约AC米兰</span><span data-v-7d1a9adc="" class="date">2021年6月</span></div>
            <p data-v-7d1a9adc="" class="desc">成为{{$store.state.appInfo.title}}品牌代言人</p>
          </div>
        </div>
      </div>
    </div>
    <div data-v-600960a6="" class="main" v-if="nav == 1">
      <div data-v-e6fd6dd0="" data-v-600960a6="" class="main">
        <div data-v-e6fd6dd0="" class="history">
          <ul data-v-e6fd6dd0="" class="list">
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="/static/image/sport/QQ20250830-180146.png" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}正式进入世界杯</div>
                  <p data-v-e6fd6dd0="">2021年9月</p>
                  <p data-v-e6fd6dd0="" class="desc">携手共赢 实力见证</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="/static/image/sport/411f467207a84c6b974b6e89e74226c5.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">2019{{$store.state.appInfo.title}}年度传记</div>
                  <p data-v-e6fd6dd0="">2020年2月</p>
                  <p data-v-e6fd6dd0="" class="desc">2019{{$store.state.appInfo.title}}年度报告，感谢会员一路相随</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="/static/image/sport/820.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}正式收购暴风竞技</div>
                  <p data-v-e6fd6dd0="">2020年2月</p>
                  <p data-v-e6fd6dd0="" class="desc">博彩行业全方位多元化布局</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!----><!---->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sponsor',
  data() {
    return { nav: 0 };
  },
  created() {
    let that = this;
  },
  methods: {
    changNav(val) {
      this.nav = val;
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 - 已统一白色背景 */
.common-banner .common-bannerimg[data-v-600960a6] {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
}
.left-label[data-v-600960a6] {
  display: block;
  height: 0.25rem;
  margin-bottom: 0.1rem;
  font-size: 0.18rem;
  font-weight: 700;
  line-height: 0.25rem;
  color: #333; /* 深色文字确保白色背景下可读性 */
}
.order-list[data-v-600960a6] {
  width: auto;
  height: auto;
  padding: 0 0 0 0.28rem;
  margin: 0 0 0.2rem 0;
  font-size: 0.14rem;
  color: #666;
  list-style-type: decimal-leading-zero;
}
.order-list li[data-v-600960a6] {
  display: list-item;
  height: auto;
  padding-left: 0.1rem;
  margin-bottom: 0.1rem;
  line-height: 0.28rem;
}
.gray-con[data-v-600960a6] {
  width: auto;
  padding: 0.2rem 0.15rem 0.3rem;
  margin: 0 auto;
  background-color: #f5f5f5; /* 浅灰背景区分区域 */
}
.center-text[data-v-600960a6] {
  margin: 0 auto 0.15rem;
  font-size: 0.14rem;
  line-height: 0.25rem;
  color: #666;
}
.table-con[data-v-600960a6] {
  margin: 0 auto 0.3rem;
  overflow-x: auto;
  border-radius: 4px;
}
.table-con .table[data-v-600960a6] {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  border: 1px solid #eee;
}
.table-con .table tr:first-child th[data-v-600960a6] {
  border-top: none;
}
.table-con .table th[data-v-600960a6] {
  padding: 0.11rem 0;
  font-size: 0.14rem;
  font-weight: 400;
  color: #333;
  white-space: nowrap;
  background-color: #f9f9f9;
  border-color: #eee;
  border-bottom: none;
}
.table-con .table th[data-v-600960a6]:first-child {
  padding-left: 0.1rem;
  border-left: none;
}
.table-con .table th[data-v-600960a6]::last-child {
  padding-right: 0.1rem;
  border-right: none;
}
.table-con .table td[data-v-600960a6] {
  padding: 2.66667vw 2.13333vw;
  font-size: 0.14rem;
  font-weight: 400;
  line-height: 1.2;
  color: #666;
  text-align: center;
  vertical-align: middle;
  background-color: #fff;
  border: 1px solid #eee;
}
.middle-btn[data-v-600960a6] {
  display: block;
  width: 1.65rem;
  height: 0.52rem;
  margin: 0.1rem auto 0.29rem;
  font-size: 0.16rem;
  line-height: 0.52rem;
  color: #fff;
  text-align: center;
  background-color: #4285f4; /* 蓝色按钮突出交互 */
  border-radius: 100px;
  border: none;
  cursor: pointer;
}
.input-err-icon[data-v-600960a6] {
  background-image: url(/static/style/tan.png);
  background-repeat: no-repeat;
  width: 16px;
  height: 16px;
  background-size: 100%;
  margin-right: 3px;
}
.input-err-border[data-v-600960a6] {
  border-bottom: 1px solid #d91c1c !important; /* 红色错误提示 */
}
.input-err-text[data-v-600960a6] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #d91c1c !important;
  font-weight: 400;
  margin-top: -3px;
}

/* 页面主体 - 核心白色背景 */
.mien[data-v-600960a6] {
  background: #fff; /* 主体背景改为白色 */
  min-height: 100vh; /* 确保全屏覆盖 */
}
.mien .nav[data-v-600960a6] {
  height: 50px;
  text-align: center;
  background-color: #fff;
  border-bottom: 1px solid #eee; /* 浅灰边框区分导航栏 */
  display: flex;
  justify-content: center;
}
.mien .nav .tab[data-v-600960a6] {
  display: inline-block;
  padding: 0 20px;
  overflow: hidden;
  font-size: 15px;
  line-height: 50px;
  color: #333; /* 导航文字深色 */
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}
.mien .nav .tab.active[data-v-600960a6] {
  color: #4285f4; /* 激活态蓝色文字 */
  font-weight: 500;
}
.mien .nav .tab.active[data-v-600960a6]:after {
  display: block;
  width: 30px;
  height: 3px;
  margin: -2px auto 0 auto;
  content: '';
  background: #4285f4; /* 激活态蓝色下划线 */
  border-radius: 1.5px;
}

/* 赞助列表模块 */
.main[data-v-7d1a9adc] {
  padding: 20px 0;
  background-color: #f9f9f9; /* 浅灰背景区分内容区与主体 */
}
.main .list-box[data-v-7d1a9adc] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 15px 0 0 0;
  margin: 0 15px 15px;
  background-color: #fff; /* 列表项白色背景 */
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05); /* 轻微阴影增强层次感 */
  overflow: hidden;
}
.main .list-box .img-box[data-v-7d1a9adc] {
  position: relative;
  min-height: 130px;
  background-color: #f5f5f5; /* 图片加载前浅灰占位 */
}
.main .list-box .img-box img[data-v-7d1a9adc] {
  width: 100%;
  display: block;
  border-radius: 8px 8px 0 0;
}
.main .list-box .img-box .icon-play[data-v-7d1a9adc] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 42px;
  height: 42px;
  margin: auto;
  background: url(/static/image/icon-play.663b8348.png) no-repeat;
  background-size: 100% 100%;
  z-index: 1;
}
.main .list-box .title[data-v-7d1a9adc] {
  padding: 0;
  margin-bottom: 5px;
  color: #333; /* 标题深色 */
  font-size: 16px;
  letter-spacing: 0;
  line-height: 17px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.main .list-box .title .title-content[data-v-7d1a9adc] {
  -webkit-box-flex: 20vw;
  -ms-flex: 20vw;
  flex: 20vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.main .list-box .date[data-v-7d1a9adc] {
  color: #999; /* 日期浅灰 */
  font-size: 14px;
  margin-top: 1.5px;
  margin-left: 5px;
  letter-spacing: 0;
  line-height: 15px;
  text-align: right;
  white-space: nowrap;
}
.main .list-box p[data-v-7d1a9adc] {
  font-size: 14px;
  color: #666; /* 描述中灰 */
  letter-spacing: 0;
  line-height: 15px;
  margin: 0;
}
.main .list-box p.date[data-v-7d1a9adc] {
  color: #999;
}
.main .list-box .info[data-v-7d1a9adc] {
  background-color: #fff;
  padding: 15px;
  border-radius: 0 0 8px 8px;
}

/* 品牌历程模块 - 关键修复：移除所有深色背景 */
.main[data-v-e6fd6dd0] {
  padding: 20px;
  background-color: #f9f9f9; /* 与赞助模块背景统一 */
}
.history[data-v-e6fd6dd0] {
  max-width: 800px;
  margin: 0 auto;
  padding: 15px 0;
  margin: 0 15px 0 28px;
}
.history ul li[data-v-e6fd6dd0] {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: -2px;
  border-left: 2px solid #e0e0e0; /* 浅灰时间线 */
}
/* 修复：时间点背景从黑色改为白色，避免深色块 */
.history ul li .dot-h[data-v-e6fd6dd0] {
  position: absolute;
  top: 5px;
  left: -5px;
  padding: 8px 0;
  background: #fff; /* 关键修复：原黑色背景改为白色 */
}
.history ul li .dot-h .dot[data-v-e6fd6dd0] {
  display: block;
  width: 16px;
  height: 16px;
  background: #4285f4; /* 蓝色时间点突出 */
  border-radius: 50%;
  border: 3px solid #fff;
  box-shadow: 0 0 0 2px #e8f0fe; /* 浅蓝色光晕增强层次 */
}
.history ul li .details[data-v-e6fd6dd0] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 0 0 20px 28px;
  margin-left: -2px;
  border-left: 2px solid #e0e0e0; /* 浅灰时间线延续 */
}
.history ul li .details .img-box[data-v-e6fd6dd0] {
  margin-bottom: 10px;
}
.history ul li .details .img-box img[data-v-e6fd6dd0] {
  display: block;
  width: 100%;
  min-height: 114px;
  border-radius: 8px;
  object-fit: cover;
}
/* 修复：播放图标定位错误 */
.history ul li .details .img-box .icon-play[data-v-e6fd6dd0] {
  position: absolute;
  top: 50%;
  right: 0;
  bottom: auto;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 42px;
  height: 42px;
  margin: auto;
  background: url(/static/image/icon-play.663b8348.png) no-repeat;
  background-size: 100% 100%;
  z-index: 1;
}
.history ul li .details .title[data-v-e6fd6dd0] {
  padding: 8px 0 0;
  font-size: 16px;
  line-height: 16px;
  color: #333; /* 标题深色 */
  margin: 0 0 8px 0;
  font-weight: 500;
}
.history ul li .details p[data-v-e6fd6dd0] {
  margin-top: 5px;
  font-size: 14px;
  color: #999; /* 日期浅灰 */
  margin: 0 0 5px 0;
}
.history ul li .details p.desc[data-v-e6fd6dd0] {
  font-size: 14px;
  line-height: 20px;
  color: #666 !important; /* 描述中灰 */
  text-align: justify;
}

/* 弹窗模块 - 统一白色背景与半透明遮罩 */
.video-wrap[data-v-7d1a9adc],
.video-wrap[data-v-e6fd6dd0] {
  position: fixed;
  top: 0;
  z-index: 999999;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); /* 半透明黑遮罩，确保内容可见 */
}
.video-wrap .video-pop[data-v-7d1a9adc],
.video-wrap .video-pop[data-v-e6fd6dd0] {
  position: relative;
  top: 50%;
  width: 90%;
  max-width: 500px;
  max-height: 70vh;
  padding: 15px;
  margin: 0 auto;
  transform: translateY(-50%);
  background-color: #fff; /* 弹窗白色背景 */
  border-radius: 8px;
  -webkit-box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
}
.video-wrap .video-pop video[data-v-7d1a9adc],
.video-wrap .video-pop video[data-v-e6fd6dd0] {
  width: 100%;
  height: auto;
  border-radius: 4px;
}
.video-wrap .video-pop .video-close[data-v-7d1a9adc],
.video-wrap .video-pop .video-close[data-v-e6fd6dd0] {
  position: absolute;
  top: -34px;
  right: 16px;
  display: block;
  float: none;
  width: 27px;
  height: 47px;
  margin: 0 auto;
  background: url(/static/style/x.png) no-repeat;
  background-size: 100% 100%;
}

/* 图片弹窗修复 */
.pop-img-backdrop[data-v-7d1a9adc],
.pop-img-backdrop[data-v-e6fd6dd0] {
  position: fixed;
  top: 0;
  z-index: 99999;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); /* 半透明遮罩 */
}
.pop-img-backdrop .pop-img[data-v-7d1a9adc],
.pop-img-backdrop .pop-img[data-v-e6fd6dd0] {
  position: relative;
  top: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 90%;
  max-width: 500px;
  max-height: 70vh;
  padding: 15px;
  margin: 0 auto;
  transform: translateY(-50%);
  background: #fff; /* 弹窗白色背景 */
  border-radius: 8px;
  -webkit-box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
}
.pop-img-backdrop .pop-img .close[data-v-7d1a9adc],
.pop-img-backdrop .pop-img .close[data-v-e6fd6dd0] {
  position: absolute;
  top: -35px;
  right: 15px;
  display: block;
  float: none;
  width: 27px;
  height: 47px;
  margin: 0 auto;
  background: url(/static/style/x.png) no-repeat;
  background-size: 100% 100%;
}
.pop-img-backdrop .pop-img img[data-v-7d1a9adc],
.pop-img-backdrop .pop-img img[data-v-e6fd6dd0] {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 4px;
}
.pop-img-backdrop .pop-img .pop-img-cycle[data-v-7d1a9adc],
.pop-img-backdrop .pop-img .pop-img-cycle[data-v-e6fd6dd0] {
  height: 200px;
  overflow: hidden;
}
.pop-img-backdrop .pop-img .imgh[data-v-7d1a9adc],
.pop-img-backdrop .pop-img .imgh[data-v-e6fd6dd0] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* 半透明遮罩，确保播放图标可见 */
}
.pop-img-backdrop .pop-img .icon-play[data-v-7d1a9adc],
.pop-img-backdrop .pop-img .icon-play[data-v-e6fd6dd0] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 42px;
  height: 42px;
  margin: auto;
  background: url(/static/image/icon-play.663b8348.png) no-repeat;
  background-size: 100% 100%;
  z-index: 1;
}
.pop-img-backdrop .pop-img .swiper-button[data-v-7d1a9adc],
.pop-img-backdrop .pop-img .swiper-button[data-v-e6fd6dd0] {
  position: absolute;
  top: auto;
  bottom: 30px;
  z-index: 100;
  display: block;
  width: 33px;
  height: 33px;
  cursor: pointer;
  outline: 0;
}
.pop-mask .pop-box .swiper-button.swiper-button-prev[data-v-7d1a9adc] {
  background: url(/static/style/right.png) no-repeat;
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/main/sponsor.vue